import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export const GiftCartProductShopifyMap =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.IN]: {
          variantId: 'gid://shopify/ProductVariant/43919354626118',
          checkouturl:
            'https://ultrahumanstore.myshopify.com/cart/43919354626118:1?channel=buy_button',
          price: 28499,
          offerPrice: 28499,
          discountCode: '',
        },
      }
    : {
        [ShopifyStore.IN]: {
          variantId: 'gid://shopify/ProductVariant/54779400061001',
          checkouturl:
            'https://uhtesting.myshopify.com/cart/54779400061001:1?channel=buy_button',
          price: 28499,
          offerPrice: 28499,
          discountCode: '',
        },
      };

export const buildCheckoutUrl = (
  store: ShopifyStore,
  gifteeName: string,
  gifteeEmail: string,
  discountCode?: string
): string => {
  const storeConfig =
    GiftCartProductShopifyMap[store as keyof typeof GiftCartProductShopifyMap];
  if (!storeConfig) {
    return '';
  }
  const url = new URL(storeConfig.checkouturl);
  url.searchParams.set('attributes[giftee_name]', gifteeName);
  url.searchParams.set('attributes[giftee_email]', gifteeEmail);
  // url.searchParams.set('discount', storeConfig.discountCode);
  if (discountCode) {
    url.searchParams.set('discount', discountCode);
  } else {
    url.searchParams.set('discount', storeConfig.discountCode);
  }
  return url.toString();
};
